window.addEventListener("load", function () {
  
document.querySelectorAll('.tabs').forEach(tabs => {
  const tabBtns = tabs.querySelectorAll('.tab-btn');
  const tabContents = tabs.querySelectorAll('.tab-content');

  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      // reset active
      tabBtns.forEach(b => b.classList.remove('active'));
      tabContents.forEach(c => c.classList.remove('active'));

      // thêm active vào cái đang click
      btn.classList.add('active');
      const tabId = btn.dataset.tab;
      tabs.querySelector(`.tab-content[data-tab="${tabId}"]`).classList.add('active');
    });
  });
});


});
